import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ReservationConfirmee from "@/pages/ReservationConfirmee";
import Flyer from "@/pages/Flyer";
import Tracking from "@/pages/Tracking";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/suivi" element={<Tracking />} />
          <Route path="/reservation/confirmee" element={<ReservationConfirmee />} />
          <Route path="/flyer" element={<Flyer />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/tableau" element={<AdminDashboard />} />
          <Route path="/paiement/succes" element={<PaymentSuccess />} />
          <Route path="/paiement/annule" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
